import { lbBrand } from '@fuse/colors';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    '&.user': {
      '& .username, & .email': {
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
          easing: theme.transitions.easing.easeInOut,
        }),
      },
    },
  },
  avatar: {
    width: 72,
    height: 72,
    position: 'absolute',
    top: 92,
    padding: 8,
    background: theme.palette.background.default,
    boxSizing: 'content-box',
    left: '50%',
    color: '#333',
    transform: 'translateX(-50%)',
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
    '& > img': {
      borderRadius: '50%',
    },
  },
}));

function UserNavbarHeader() {
  const user = useSelector(({ auth }) => auth.user);

  const classes = useStyles();

  return (
    // Transparent background so the sidebar surface shows through. The text
    // colour is set explicitly rather than left to MuiAppBar.colorPrimary; both
    // Typography below use color="inherit", and the email stays de-emphasised
    // via its opacity-50. The borderBottom overrides colorPrimary's 2px red
    // card-header accent, closing this block off from the navigation.
    // The padding is kept tight so the block reads as a block: the old pb-64
    // reserved room for an avatar this component never renders.
    <AppBar
      position="static"
      color="primary"
      elevation={0}
      classes={{ root: classes.root }}
      className="user relative flex flex-col items-center justify-center pt-20 pb-20 mb-8 z-0"
      style={{
        background: 'transparent',
        color: lbBrand.black,
        borderBottom: `1px solid ${lbBrand.navDivider}`,
      }}
    >
      <Typography className="username text-16 whitespace-no-wrap" color="inherit">
        {user.data.displayName}
      </Typography>
      <Typography className="email text-13 mt-8 opacity-50 whitespace-no-wrap" color="inherit">
        {user.data.email}
      </Typography>
    </AppBar>
  );
}

export default UserNavbarHeader;
